import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import IllustrationAlert from "@repo/icons/colored/IllustrationAlert";
import ArrowRight from "@repo/icons/default/ArrowRight";

import { Button } from "@/components/ui/button/button";
import {
  EmptyStateV2Description,
  EmptyStateV2Root,
  EmptyStateV2Title,
} from "@/components/ui/empty-state/empty-state-v2";
import { Page } from "@/components/ui/layout/page/page";
import { RoundedLayout } from "@/components/ui/layout/rounded-layout";
import { generateLivanceContactUrl } from "@/lib/helpers/contact-url";

const CafDocumentsBlockedPage = (): JSX.Element => {
  const handleContact = (): void => {
    const url = generateLivanceContactUrl("whatsapp");
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <RoundedLayout>
      <Page
        className="flex flex-col justify-between pb-0 px-6"
        showCustomerIoContainer={false}
      >
        <EmptyStateV2Root className="gap-4 py-4">
          <IllustrationAlert size={80} aria-hidden="true" />

          <div>
            <EmptyStateV2Title className="text-2xl font-medium">
              Encontramos pendências nos documentos enviados
            </EmptyStateV2Title>
            <EmptyStateV2Description className="text-md">
              Entre em contato com o nosso time para regularizar a situação.
            </EmptyStateV2Description>
          </div>
        </EmptyStateV2Root>

        <div className="sticky bottom-0 flex flex-col gap-3 pt-4 pb-4 bg-white">
          <Button fullWidth onClick={handleContact}>
            <div className="flex flex-row items-center justify-center gap-2">
              Entrar em contato
              <ArrowRight size={24} aria-hidden="true" />
            </div>
          </Button>
        </div>
      </Page>
    </RoundedLayout>
  );
};

export const Route = createFileRoute("/caf-documents-blocked/")({
  component: CafDocumentsBlockedPage,
});
